import { app, db } from "@/firebase/init.js";
import {
  collection,
  query,
  getDocs,
  getDoc,
  setDoc,
  doc,
} from "firebase/firestore"; // Create, Add Collection
import {
  getDatabase,
  ref,
  onValue,
  limitToLast,
  set,
  update,
  push,
  child,
  query as dbQuery,
  orderByChild,
  remove,
} from "firebase/database";

const database = getDatabase(app);
const lessonsModule = {
  namespaced: true, // automatically added
  state: {
    video_content: {},
    comments: {},
    attachments: [],
    analytics: {},
    isLoading: true,
    lastComment: null,
    comment: {},
  },
  getters: {
    content: (state) => state.video_content,
    comments: (state) => state.comments,
    comment: (state) => state.comment,
    attachments: (state) => state.attachments,
    loading: (state) => state.isLoading,
    analytics: (state) => state.analytics,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    setVideo(state, payload) {
      state.video_content = payload;
    },
    setVideoAnalytics(state, payload) {
      state.analytics = payload;
    },
    setVideoContents(state, payload) {
      state.analytics = payload;
    },
    setVideoComments(state, payload) {
      state.comments = payload;
    },
    setLastComment(state, payload) {
      state.lastComment = payload;
    },
    setComment(state, payload) {
      state.comment = payload;
    },
    setAttachments(state, payload) {
      state.attachments = payload;
    },
    // updateComment(state, payload)
  },
  actions: {
    async getSingleVideo({ commit }, payload) {
      const video = await getDoc(doc(db, "Videos", payload));
      commit("setLoading", false);
      commit("setVideo", video.data());
    },

    getVideoContents({ commit }, { lesson_id }) {
      commit("setLoading", true);
      const videoContents = ref(database, `contents/${lesson_id}`);
      commit("setVideoComments", {});
      onValue(videoContents, (snapshot) => {
        const data = snapshot.val() ?? {};
        commit("setVideoContents", data);
      });
      commit("setLoading", false);
    },

    // comments and replies
    async getVideoCommentsAndLoad({ dispatch }, payload) {
      const value = (await dispatch("_GENERATE_COMMENTS_LIMIT_")) || 4;

      onValue(
        dbQuery(
          ref(database, `Comments/${payload}`),
          orderByChild("created_date"),
          limitToLast(value)
        ),
        (snapshot) => {
          dispatch("paginationSnapshot", {
            snapshot,
            type: "load",
            id: payload,
          });
        }
      );
    },

    _GET_COMMENT_LENGTH_(_, { comments }) {
      return new Promise((resolve) =>
        onValue(comments, (snapshot) =>
          resolve(snapshot.val() ? Object.keys(snapshot.val()).length : 0)
        )
      );
    },

    _GENERATE_COMMENTS_LIMIT_({ state }) {
      const { comments, count } = state.comments;
      const length = count - (comments || []).length;
      if (length) {
        if (length >= 4) {
          return (comments || []).length + 4;
        } else {
          return (comments || []).length + length;
        }
      }
      return length;
    },

    async paginationSnapshot({ dispatch, commit }, { snapshot, id }) {
      const data = snapshot.val();
      const originalComments = ref(database, `Comments/${id}`);
      const count = await dispatch("_GET_COMMENT_LENGTH_", {
        comments: originalComments,
      });
      let result = {
        comments: [],
        count,
      };

      if (!data) {
        commit("setVideoComments", {});
        return;
      }

      console.log(data);
      result.comments = Object.entries(data)
        .map(([key, value]) =>
          Object.assign(value, {
            parent_id: key,
          })
        )
        .sort(() => -1);

      // set the count of comments
      commit("setVideoComments", result);

      // store last comment
      const lastComment = result.comments[result.comments.length - 1] || null;
      commit("setLastComment", lastComment);
    },

    async addComment(_, { video_id, comment }) {
      // const comments = state.comments;
      const commentKey = push(child(ref(database), `Comments/${video_id}`)).key;
      const videoCommentsRef = ref(
        database,
        `Comments/${video_id}/${commentKey}`
      );

      // await this.dispatch('notificationModule/CreateMyNotify', {
      //   comment: { ...comment, id: commentKey },
      //   video: state.video_content,
      //   path: `${path}/comments/${commentKey}`,
      //   user: {
      //     ...user,
      //     name: `${user.firstName} ${user.lastName}`,
      //   },
      //   type: 'ADMIN_COMMENT',
      // });

      await set(videoCommentsRef, comment);
    },

    // comment page
    getSelectedComment({ commit }, { video_id, comment_id }) {
      commit("setLoading", true);
      const comment = ref(database, `Comments/${video_id}/${comment_id}`);
      commit("setComment", {});

      return new Promise((resolve) => {
        onValue(comment, (snapshot) => {
          const data = snapshot.val();
          if (!data) {
            resolve(false);
            return;
          }
          commit("setComment", {
            ...data,

            parent_id: comment_id,
          });
          resolve(true);
          commit("setLoading", false);
        });
      });
    },

    // eslint-disable-next-line no-unused-vars
    async updateNotification(_, payload) {
      // const comment = state.comment;
      const notifications =
        this.getters["notificationModule/notifications"] || [];
      const findNotificationByCommentId = notifications.find(
        (e) => e?.id === payload
      );

      const notificationRef = ref(
        database,
        `Notifications/${findNotificationByCommentId?.user_id}/${findNotificationByCommentId?.id}`
      );
      if (findNotificationByCommentId) {
        Object.assign(findNotificationByCommentId, { is_read: true });
        console.log(findNotificationByCommentId, payload);
        await update(notificationRef, findNotificationByCommentId);
      }
    },

    async addReply({ state, commit }, { video_id, reply, comment_id }) {
      const replyKey = push(
        child(ref(database), `Comments/${video_id}/${comment_id}`)
      ).key;
      const comment = JSON.parse(JSON.stringify(state.comment));
      // comment.replies.push(reply);
      comment.replies = {
        ...comment.replies,
        [replyKey]: {
          ...reply,
          id: replyKey,
        },
      };
      comment.replies_count = (comment.replies_count || 0) + 1;
      const commentRef = ref(database, `Comments/${video_id}/${comment_id}`);
      await update(commentRef, comment);
      commit("setComment", comment);

      Object.assign(state.comment, comment);

      // await set(videCommentsRef, comment);
    },

    async getAttachments({ commit }, payload) {
      const data = await getDocs(
        query(collection(db, `Videos/${payload}/Files`))
      );
      let result = [];
      if (!data.empty) {
        data.forEach((e) => {
          result.push({
            id: e.id,
            ...e.data(),
          });
        });
      }
      commit("setAttachments", result);
    },

    // upload new attachment
    addAttachment({ state, commit }, { file, video_id }) {
      const documentReference = doc(collection(db, `Videos/${video_id}/Files`));
      const result = {
        ...file,
        id: documentReference.id,
        created_date: new Date().toISOString(),
      };
      setDoc(documentReference, result);
      commit("setAttachments", [...state.attachments, result]);
    },
    // delete comment and reply
    async deleteItem({ state }, { item, type }) {
      const commentRef = ref(
        database,
        `Comments/${item.content_id}/${item.parent_id || item.comment_id}`
      );
      if (type === "comment") {
        await remove(commentRef);
      } else {
        const comment =
          state.comments?.comments?.find(
            (e) => e.parent_id === item.comment_id
          ) || state.comment;
        if (!comment) return;
        console.log(item);

        for (let reply in comment.replies) {
          if (reply === item.id) {
            delete comment.replies[reply];
          }
        }

        Object.assign(comment, {
          replies: comment.replies,
          replies_count: Object.keys(comment.replies || {}).length,
        });
        console.log(comment);
        // const replies = comment.replies.filter((e) => e.id !== item.id);

        // Object.assign(comment, {
        //   replies: replies,
        //   replies_count: replies.length || 0,
        // });

        await update(commentRef, comment);
      }
    },
  },
};

export default lessonsModule;
